// Lightweight animated background (CSS-only, GPU-friendly)
// Subtle "aurora" blobs using transforms (no canvas, minimal paints)
import { useEffect } from "react";
import { motionPaused } from "./motion";

export default function ParticlesBackground() {
  useEffect(() => {
    if (motionPaused()) document.documentElement.dataset.motion = "paused";
  }, []);
  return (
    <>
      <style
        dangerouslySetInnerHTML={{
          __html: `
          .aurora-bg { 
            position: fixed; inset: 0; z-index: -1; pointer-events: none; overflow: hidden;
            background:
              radial-gradient(900px 600px at 15% 20%, rgba(56, 189, 248, 0.06), transparent 60%),
              radial-gradient(800px 500px at 85% 25%, rgba(168, 85, 247, 0.05), transparent 60%),
              linear-gradient(180deg, #0b1020 0%, #0e1222 100%);
          }

          .aurora-layer {
            position: absolute; inset: -20%; opacity: 0.7; 
            mix-blend-mode: screen;
          }

          .aurora-blob {
            position: absolute; width: 60vw; height: 60vw; border-radius: 45% 55% 55% 45% / 45% 55% 45% 55%;
            background: radial-gradient(40% 40% at 50% 50%, var(--c) 0%, transparent 60%);
            will-change: transform;
            animation: auroraMove 26s ease-in-out infinite;
            transform: translate3d(0,0,0);
          }

          .aurora-blob:nth-child(1) { --c: rgba(56, 189, 248, 0.16); top: -10%; left: -10%; animation-duration: 28s; }
          .aurora-blob:nth-child(2) { --c: rgba(168, 85, 247, 0.14); right: -15%; bottom: -20%; animation-duration: 32s; animation-delay: -6s; }
          .aurora-blob:nth-child(3) { --c: rgba(16, 185, 129, 0.12); right: -20%; top: 30%; animation-duration: 36s; animation-delay: -12s; }

          @keyframes auroraMove {
            0%   { transform: translate3d(-8%, -6%, 0) scale(1.00) rotate(0deg); }
            50%  { transform: translate3d( 8%,  6%, 0) scale(1.05) rotate(2deg); }
            100% { transform: translate3d(-8%, -6%, 0) scale(1.00) rotate(0deg); }
          }

          :root[data-motion="paused"] .aurora-blob { animation-play-state: paused; }

          @media (prefers-reduced-motion: reduce) {
            .aurora-blob { animation: none !important; }
          }
        `,
        }}
      />
      <div className="aurora-bg select-none">
        <div className="aurora-layer">
          <span className="aurora-blob" />
          <span className="aurora-blob" />
          <span className="aurora-blob" />
        </div>
      </div>
    </>
  );
}
